var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',[_c('a-menu',{attrs:{"mode":"horizontal"}}),_c('p',{staticClass:"copyright"},[_vm._v("\n\t\t\tCopyright © 2022 Order Manager App\n\t\t\tby "),_c('a',{attrs:{"href":"https://transoft.no"}},[_vm._v("TranSoft")]),_vm._v(".\n\t\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }